import React from 'react'
import { CSSTransition } from 'react-transition-group'
import { closeModal} from '../../../actions/customModal'
import { connect } from 'react-redux';
import moment from 'moment';

class CustomModal extends React.Component {
    constructor(props){
        super(props)

        this.handleClick = this.handleClick.bind(this)
        this.handleChange = this.handleChange.bind(this)

        this.state = {
            countDown: this.props.timeout/1000,
            timer: null,
            dateVal:moment().subtract(1,'months').format('YYYY-MM-DD')
        }

    }

    UNSAFE_componentWillReceiveProps(nextProps){
        // Automatically close the message if timeout is not 0
        if( !this.props.shown && nextProps.shown && nextProps.timeout > 0 && Array.isArray(nextProps.buttonArray) && nextProps.buttonArray.length === 1 ){
            // If a new message was shown while a previous message is still showing, clear the current timer
            if(this.state.timer !== null){
                clearInterval(this.state.timer)
            }
            this.setState({
                countDown: nextProps.timeout/1000,
                timer: null
            },()=>{
                if(nextProps.autoClose){
                    this.setState({
                        timer: setInterval(()=>{
                            let newCount = this.state.countDown - 1
                            if(newCount){
                                this.setState({
                                    countDown: newCount
                                })
                            } else {
                                clearInterval(this.state.timer)
                                this.setState({timer:null},()=>{
                                    this.handleClick(0)
                                })
                            }
                        },1000)
                    })
                }
            })
        }

        if( this.props.shown && !nextProps.shown && this.state.timer !== null ){
            clearInterval(this.state.timer)
            this.setState({timer:null},()=>{
                this.handleClick(0)
            })
        }
        
        
        // this.props.dispatch(updateDateVal(this.state.dateVal))
    }

    handleClick(buttonIndex){
        if( this.props.onClick && typeof this.props.onClick === "function" ){
            this.props.onClick(buttonIndex)
            // if YES was clicked
            if(!buttonIndex){
                //dispatch to the store the date.
            }
        }
        this.props.dispatch(closeModal())
    }

    handleChange(e){

        this.setState({
            dateVal:e.target.value
        })

        
        // this.props.dispatch(updateDateVal(e.target.value))
    }

    render(){
        let {
            type,
            title,
            message,
            buttonArray,
            shown,
            isDate,
            isJson,
            data
        } = this.props


        let hasData = false

        hasData = isJson? true:false


        let typeToIcon = {
            "info": "fa fa-info-circle fa-lg text-info",
            "success": "fa fa-check-circle fa-lg text-success",
            "error": "fa fa-exclamation-circle fa-lg text-danger"
        }
        
        let typeToInput = ["string","date"]

        let aMonthAgo = moment().subtract(1,'months').format('YYYY-MM-DD')

        let getJSON = data


        return (
            <CSSTransition
                in={shown}
                appear={true}
                timeout={500}
                classNames="fade"
            >
            <div className="modal" id="global-modal" tabIndex="-1" role="dialog" aria-labelledby="global-message-modal" aria-hidden={(shown ? "false" : "true")}>
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="row align-items-center">
                            <div className="col-1 modal-icon">
                                <i className={typeToIcon[type]}></i>
                            </div>
                            <div className="col">
                                <h5 className="modal-title" id="global-message-title">
                                    {title}
                                </h5>
                            </div>
                            </div>
                        </div>
                        <div className="modal-body">
                            {message}    &nbsp;                 
                            <input type="date"  ref={this.state.dateVal} id="date-picker-box" name="date-picker-box" max={aMonthAgo} onChange={e=>this.handleChange(e)} value={this.state.dateVal} required="required" onKeyDown={(e) => e.preventDefault()}/>
                            <br></br><br></br><span><b>Note: </b>You can only archive message-queues before the <b>last 30 dayssss.</b></span>
                        </div>
                        {/* {!isDate? 
                        <div className="modal-body">
                            {message}
                        </div>
                        :
                        <div className="modal-body">
                            {message}    &nbsp;                 
                            <input type="date"  ref={this.state.dateVal} id="date-picker-box" name="date-picker-box" max={aMonthAgo} onChange={e=>this.handleChange(e)} value={this.state.dateVal} required="required" onKeyDown={(e) => e.preventDefault()}/>
                            <br></br><br></br><span><b>Note: </b>You can only archive message-queues before the <b>last 30 days.</b></span>
                        </div>
                        } */}

                        {/* {isDate?  
                            <div className="modal-body">
                                {message}    &nbsp;                 
                                <input type="date"  ref={this.state.dateVal} id="date-picker-box" name="date-picker-box" max={aMonthAgo} onChange={e=>this.handleChange(e)} value={this.state.dateVal} required="required" onKeyDown={(e) => e.preventDefault()}/>
                                <br></br><br></br><span><b>Note: </b>You can only archive message-queues before the <b>last 30 days.</b></span>
                            </div>
                        :
                            hasData? 
                            <div className="modal-body">
                                 <table class="table table-striped"> 
                                <table class="table table-borderless">                    
                                    <tbody>
                                        <tr>
                                        <th scope="col"><b>Executed At:</b>  {getJSON && getJSON.updated_at}</th>
                                        </tr>
                                        <tr>
                                        <th scope="col"><b>Process Type:</b>  {getJSON && getJSON.process_type}</th>
                                        </tr>
                                        <tr>
                                        <th scope="col"><b>Message Log:</b></th>
                                        </tr>
                                        <tr class="table-secondary">
                                        <td>{getJSON && getJSON.message_log}</td>
                                        </tr>
                                        <tr>
                                        <th scope="col"><b>Arguments:</b></th>
                                        </tr>
                                        <tr>
                                        <td style={{overflowWrap:"anywhere"}} class="table-secondary">{getJSON && getJSON.message_arguments}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            :
                            <div className="modal-body">
                                {message} 
                            </div>   
                        } */}
                        <div className="modal-footer justify-content-center">
                            {
                                buttonArray.map((buttonText,buttonIndex)=>(
                                    <div className="col-2" key={buttonIndex}>
                                    <button 
                                        type="button" 
                                        className="btn btn-secondary" 
                                        data-dismiss="modal" 
                                        onClick={e=>this.handleClick(buttonIndex)}>{buttonText} { buttonArray.length === 1 && this.props.autoClose ? `(${this.state.countDown})` : null}</button>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
            </CSSTransition>
        )
    }
}

function mapStateToProps(state){
    return {...state.customModal}
}

export default connect(mapStateToProps)(CustomModal)


// WEBPACK FOOTER //
// ./src/components/utilities/modals/CustomModal.js